import React from 'react';
import '../styles/legal.css';

export const PrivacyPage = () => (
  <div className="legal-page">
    <div className="legal-inner">
      <a href="/" className="legal-back">← Back to Stimuli Central</a>
      <h1 className="legal-title">Privacy Policy</h1>
      <p className="legal-updated">Last updated: June 2026</p>

      <section className="legal-section">
        <h2>What we collect</h2>
        <p>We collect your email address, display name, and session data (trial results, deck usage) to operate the app. We do not collect payment information directly — payments are handled by Stripe.</p>
      </section>

      <section className="legal-section">
        <h2>How we use your data</h2>
        <p>Your data is used solely to provide the Stimuli Central service: displaying your decks, tracking your session history, and generating progress reports. We do not sell or share your data with third parties for advertising purposes.</p>
      </section>

      <section className="legal-section">
        <h2>Data storage</h2>
        <p>All data is stored on Google Firebase (Firestore and Firebase Storage), hosted in the United States. Photos you upload are stored in Firebase Storage and are only accessible to your account.</p>
      </section>

      <section className="legal-section">
        <h2>Third-party services</h2>
        <p>We use Pexels to source stock photos shown during sessions. When you search for images, your query is sent to the Pexels API. Pexels is governed by their own privacy policy.</p>
      </section>

      <section className="legal-section">
        <h2>Data deletion</h2>
        <p>You can delete your account and all associated data at any time by contacting us at <a href="mailto:hello@stimulicentral.org">hello@stimulicentral.org</a>. We will process deletion requests within 30 days.</p>
      </section>

      <section className="legal-section">
        <h2>HIPAA notice</h2>
        <p>Stimuli Central is a stimulus training tool, not a covered entity under HIPAA. <strong>Do not enter real learner names, client identifiers, diagnoses, or any Protected Health Information (PHI) into Stimuli Central.</strong> Use initials, pseudonyms, or codes to identify learners. You — the therapist or educator — are solely responsible for ensuring your use of this app complies with HIPAA and any other applicable privacy laws in your jurisdiction.</p>
      </section>

      <section className="legal-section">
        <h2>Contact</h2>
        <p>Questions about your privacy? Email us at <a href="mailto:hello@stimulicentral.org">hello@stimulicentral.org</a>.</p>
      </section>
    </div>
  </div>
);
